export class EditForm {
  email: string;
  name: string;
  surname: string;
  phoneNumber: string;
  birthDate: string;
  birthPlace: string;


  constructor(email: string, name: string, surname: string, phoneNumber: string, birthDate: string, birthPlace: string) {
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.phoneNumber = phoneNumber;
    this.birthDate = birthDate;
    this.birthPlace = birthPlace;
  }
}
